/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { Link } from 'react-router-dom';

import { FiLink } from 'react-icons/fi';

export const columnsLinks: any[] = [
  {
    name: 'languageName',
    title: 'Name',
  },

  {
    name: 'linkUrl',
    title: 'Link',
    getCellValue: (row: any) => {
      const [pathname, search] = row.linkUrl.split('?');
      const toObject = {
        pathname: pathname || row.linkUrl,
        search: search ? `?${search}` : '',
      };
      const iconProperties = (
        <>
          <Link to={toObject} target="_blank">
            <FiLink size={22} color={'#ff0000'} />
          </Link>
        </>
      );

      return iconProperties;
    },
  },

  {
    name: 'copyUrl',
    title: 'Copy Url',
  },
];
